<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">色卡领取名单</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1" :style="{ marginRight: '24px' }">
            <span class="label">时间</span>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="YYYY-MM-DD"
            />
          </div>
          <div class="item col-1">
            <div class="label" style="width: 117px">用户名/微信名:</div>
            <label
              ><input
                type="text"
                style="width: 200px"
                class="cg-input"
                v-model="username"
            /></label>
          </div>
          <div class="item col-1">
            <div class="label" style="width: 117px">手机号码:</div>
            <label
              ><input
                type="number"
                style="width: 200px"
                class="cg-input"
                v-model="phone"
            /></label>
          </div>
          <div class="item col-1">
            <div class="form-options">
              <el-button size="small" class="custom-btn" @click="search"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table :data="list" border style="width: 100%" class="custom-table">
      <el-table-column align="center" prop="date" label="领取时间">
        <template #default="scope">
          {{ $day(scope.row.date).format("YYYY-MM-DD") }}
        </template>
      </el-table-column>
      <el-table-column align="center" width="360" show-overflow-tooltip>
        <template #header>
          <div style="display: flex; width: 100%">
            <div style="width: 100px">微信头像</div>
            <div style="flex: 1">用户名/微信名</div>
          </div>
        </template>
        <template #default="scope">
          <div style="display: flex; width: 100%; align-items: center">
            <div style="width: 100px; display: flex; justify-content: center">
              <img
                v-if="scope.row.avatarUrl"
                :src="getFullImgUrl(scope.row.avatarUrl)"
                alt=""
                style="width: 45px; height: 45px; border-radius: 50%"
              />
            </div>
            <div style="flex: 1; width: 50%; text-align: center">
              {{ scope.row.nickName }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="phone" label="手机号码" />
      <!-- 加载更多插槽，和前面页面统一 -->
      <template #append>
        <div
          class="load-more"
          :class="{ 'no-more': noMore }"
          v-if="list.length"
          @click="loadMore"
        >
          {{ noMore ? "没有数据了~" : "点击加载下一页" }}
        </div>
      </template>
    </el-table>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, watch } from "vue";
const { proxy } = getCurrentInstance();

const dateRange = ref([]); //时间范围 [开始日期, 结束日期]
const username = ref("");
const list = ref([]); //表格
const phone = ref(""); //手机号码

// 分页变量
const pages = ref({ page: 1, size: 50 });
const noMore = ref(false);
const loading = ref(false);

const days = () => {
  const end = new Date();
  const start = new Date();
  start.setMonth(start.getMonth() - 1);
  dateRange.value = [formatDate(start), formatDate(end)];
};

const formatDate = (date) => {
  if (!date) return "";
  const time = new Date(date);
  const year = time.getFullYear();
  const month = (time.getMonth() + 1).toString().padStart(2, "0");
  const day = time.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// 缓存值
const STORAGE_KEY = "/publish-clothes/colorcard/colorcardReceiver";

// 监听查询条件
watch([username, dateRange, phone], () => {
  const searchParams = {
    username: username.value,
    dateRange: dateRange.value,
    phone: phone.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      dateRange.value = cache.dateRange ?? [];
      phone.value = cache.phone ?? "";
      username.value = cache.username ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

// 查询：重置页码清空列表
const search = () => {
  pages.value.page = 1;
  noMore.value = false;
  list.value = [];
  getList();
};
// 加载下一页
const loadMore = async () => {
  await getList(true);
};

const getFullImgUrl = (url) => {
  if (!url) return "";
  if (/^https?:\/\//.test(url)) {
    return url;
  }
  return `https://${url}`;
};

const getList = async (isLoadMore = false) => {
  if (noMore.value || loading.value) return;
  const beginTime =
    dateRange.value && dateRange.value[0] ? dateRange.value[0] : "";
  const endTime =
    dateRange.value && dateRange.value[1] ? dateRange.value[1] : "";
  const sendata = {
    currentPage: pages.value.page,
    pageSize: pages.value.size,
    phone: phone.value,
    nickName: username.value,
    beginTime: beginTime,
    endTime: endTime,
  };
  console.log(sendata, "参数");
  try {
    loading.value = true;
    const res = await proxy.$api.Colorcard.getlq(sendata);
    if (res.data.code == 200) {
      const currentData = Array.isArray(res.data.data.list)
        ? res.data.data.list
        : [];
      if (pages.value.page === 1) {
        list.value = currentData;
      } else {
        list.value = [...list.value, ...currentData];
      }
      const total = res.data.data.total;
      noMore.value =
        total != null
          ? list.value.length >= total
          : currentData.length < pages.value.size;
      pages.value.page += 1;
    } else if (!isLoadMore) {
      list.value = [];
      proxy.$message.error("获取列表失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    console.error("获取列表异常：", error);
    if (!isLoadMore) list.value = [];
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  days();
  loadSearchCache();
  getList();
});
</script>

<style lang="scss" scoped>
@import "./colorcardReceiver.scss";
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
.main-panel.large {
  background-color: #fff;
}
:deep(.el-dialog) {
  margin-top: 15vh !important;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 180px;
}
.panel-title {
  color: #666;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff;
}
:deep(.el-select .el-input__inner:focus) {
  background-color: #fff;
}
:deep(.custom-table) {
  background-color: #fff !important;
  .el-table__header-wrapper {
    background-color: #fff !important;
    .el-table__header {
      background-color: #fff !important;
      th {
        background-color: #fff !important;
      }
    }
  }
  .el-table__body-wrapper {
    background-color: #fff !important;
    .el-table__body {
      background-color: #fff !important;
      td {
        background-color: #fff !important;
      }
    }
  }
}
:deep(.el-dialog--center) {
  background-color: #fff !important;
}
/* 和其他页面统一的加载更多样式 */
.load-more {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #666;
  cursor: pointer;
  &:hover {
    background: #e9ecef;
  }
  &.no-more {
    color: #999;
    cursor: default;
  }
}
</style>
